import { useContext } from 'react';
import { useQuery, QueryClient, QueryClientContext } from '@tanstack/react-query';
import { supabase } from '../../lib/supabase';

const fallbackQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
        },
    },
});

export interface UseCustomerExpertAvailabilityOptions {
    enabled?: boolean;
}

/**
 * Checks whether customer expert chat is enabled on the server.
 * Behind flag `experts.customer_chat.enabled`, checked via `expert-customer-chat` edge function.
 */
export function useCustomerExpertAvailability(options?: UseCustomerExpertAvailabilityOptions) {
    const existingClient = useContext(QueryClientContext);

    return useQuery(
        {
            queryKey: ['expert-customer-chat-availability'],
            queryFn: async (): Promise<boolean> => {
                try {
                    const { data, error } = await supabase.functions.invoke('expert-customer-chat', {
                        body: { action: 'availability' },
                    });
                    if (error) return false;
                    return data?.enabled === true;
                } catch {
                    return false;
                }
            },
            staleTime: 5 * 60 * 1000,
            enabled: options?.enabled ?? true,
        },
        existingClient ? undefined : fallbackQueryClient,
    );
}
